<template>
    <div class="header__profile display--flex accessibility--active" tabindex="0">
        <span class="header__profile__name">{{ $store.getters.firstAndLastName }}</span>
        <avatar
            class="header__profile__avatar position--relative"
            @click.native="toggleDrop"
        />
        <ul
            ref="drop"
            class="header__profile__dropdown position--absolute display--none background--white color--grey shaddow--default"
            role="navigation"
        >
            <li class="header__profile__dropdown__option capitalize">
                <router-link
                    :to="`/profile/${$store.getters.userId}`"
                    class="header__profile__dropdown__option__anchor display--block"
                    active-class="header__profile__dropdown__option__anchor--active"
                >
                    <span class="header__profile__dropdown__option__anchor__text">{{ $t('global.profile') }}</span>
                </router-link>
            </li>
            <li
                class="header__profile__dropdown__option header__profile__dropdown__option__anchor capitalize pointer"
                tabindex="0"
                @click="logout"
            >
                <span class="header__profile__dropdown__option__anchor__text">{{ $t('authentication.logout') }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
// packages
import { ref, onMounted, onUnmounted } from '@vue/composition-api';

// store
import { useActions } from '@/hooks/use-store';

export default {
    components: {
        Avatar: () => import( /* webpackChunkName: 'Avatar' */ '@/components/bundles/layout/Avatar' )
    },
    setup () {
        // toggle dropdown de perfil.
        const drop = ref( null );

        const toggleDrop = () => {
            let operation = 'remove';

            if ( !drop.value.classList.contains( 'display--none' ) ) {
                operation = 'add';
                setTimeout( () => {
                    drop.value.classList.add( 'display--none' );
                }, 500 );
            } else
                drop.value.classList.remove( 'display--none' );

            drop.value.classList[operation]( 'js-inactive' );
            drop.value.classList.toggle( 'js-active' );
        };

        // logout
        const { actions } = useActions();

        const logout = () => {
            actions( 'logout' );
        };

        // handler on click outside autocomplete
        const handleClickOutside = event => {
            if ( !event.target.classList.contains( 'header__profile__avatar' ) && drop.value.classList.contains( 'js-active' ) )
                toggleDrop();
        };

        onMounted( () => {
            document.addEventListener( 'click', handleClickOutside );
        });

        onUnmounted( () => {
            document.removeEventListener( 'click', handleClickOutside );
        });

        return { drop, toggleDrop, logout };
    }
};
</script>